import { createStyles } from '@mantine/core';
var useStyles = createStyles(function (theme, _ref) {
  var startBarHeight = _ref.startBarHeight,
    startBarWidth = _ref.startBarWidth,
    thickness = _ref.thickness,
    startBarColor = _ref.startBarColor,
    backgroundColor = _ref.backgroundColor,
    _ref$borderSize = _ref.borderSize,
    borderSize = _ref$borderSize === void 0 ? 0 : _ref$borderSize,
    _ref$glowSize = _ref.glowSize,
    glowSize = _ref$glowSize === void 0 ? 0 : _ref$glowSize;
  var topOffset = (startBarHeight - thickness * 2) / 2;
  var leftOffset = startBarWidth / 2 - 0.25;
  return {
    root: {
      position: "relative",
      "&::before": {
        content: '""',
        display: "block",
        position: "absolute",
        top: "".concat(thickness * 1.5 - borderSize, "px"),
        left: "".concat(thickness * 1.5 - borderSize, "px"),
        right: "".concat(thickness * 1.5 - borderSize, "px"),
        bottom: "".concat(thickness * 1.5 - borderSize, "px"),
        backgroundColor: backgroundColor != null ? backgroundColor : "transparent",
        borderRadius: "50%"
      },
      svg: {
        filter: glowSize > 0 ? "drop-shadow(0px 0px 8px rgba(255, 255, 255, 0." + glowSize + "))" : "none",
        circle: {
          transition: "all 300ms ease-in-out"
        }
      },
      "> div ": {
        marginRight: "".concat(thickness * 2, "px"),
        marginLeft: "".concat(thickness * 2, "px")
      }
    },
    withStartBar: {
      "&::after": {
        content: '""',
        display: "block",
        position: "absolute",
        left: "calc(50% - ".concat(leftOffset, "px)"),
        width: "".concat(startBarWidth, "px"),
        top: "-".concat(topOffset, "px"),
        height: "".concat(startBarHeight, "px"),
        backgroundColor: startBarColor
      }
    },
    label: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)"
    },
    separator: {}
  };
});
export { useStyles as default };